import { AuthStatus } from './auth.types';

export const AUTH_REDIRECT_SCHEME = 'ng-whis';
export const AUTH_REDIRECT_PATH = 'redirect';
export const DEFAULT_AUTH_STATUS: AuthStatus = 'loading';
